import { render, staticRenderFns } from "./DingTalkDeptSelect.vue?vue&type=template&id=50b25966&scoped=true"
import script from "./DingTalkDeptSelect.vue?vue&type=script&lang=js"
export * from "./DingTalkDeptSelect.vue?vue&type=script&lang=js"
import style0 from "./DingTalkDeptSelect.vue?vue&type=style&index=0&id=50b25966&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b25966",
  null
  
)

export default component.exports